'use strict';

import $ from 'jquery';

function init() {
  const $badge = $('.product-page__view-count');
  const activeClass = 'active';
  const openDelay = 2000;
  const showDuration = 5000;

  setTimeout(function() {
    $badge.addClass(activeClass);
  }, openDelay);

  setTimeout(function() {
    $badge.removeClass(activeClass);
  }, openDelay + showDuration);

  $badge.click(function() {
    $(this).toggleClass(activeClass);
  });
}

export default { init };
export { init };
